// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__xdSpv","list":"BalanceDue_list__2V3X9","listRow":"BalanceDue_listRow__cfoxX","total":"BalanceDue_total__2uWkf"};